import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '@lib/components/Table/Table';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import { IconName } from '@lib/components/Modal/enums';
import { OrderingState } from '@lib/enums/urls';
import getCategoryTableColumns, {
  CategoryAnalyticsRow,
} from '../utils/getCategoryTableColumns';

interface Props {
  rows: CategoryAnalyticsRow[];
  loading: boolean;
  orderingState: OrderingState;
}

export default function CategoriesTable({
  rows,
  loading,
  orderingState,
}: Props) {
  const { t } = useTranslation();
  const columns = useMemo(() => getCategoryTableColumns(t), [t]);

  return (
    <Table
      columns={columns}
      data={rows}
      id="top-categories-by-views"
      loading={loading}
      orderingState={orderingState}
      totalEntries={rows.length}
      emptyState={
        <EmptyState
          icon={IconName.SearchOff}
          title={t('no-results-found')}
          text={t('no-results-found-text')}
        />
      }
    />
  );
}
